export const adminKeys = {
  getAdminConfigsByType: (configType: string) => ['admin-configs', configType],
};
